// discard-changes.service.ts

import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DiscardChangesService {
  private isFormDirtySubject = new BehaviorSubject<boolean>(false);
  isFormDirty$ = this.isFormDirtySubject.asObservable();

  setFormDirty(isDirty: boolean): void {
    this.isFormDirtySubject.next(isDirty);
  }
}
